
    <ng-container wp-isolated-query-space>
      <wp-calendar [static]="true"></wp-calendar>
    <ng-container wp-isolated-query-space>
  